import { type UseQueryResult, useQuery } from 'react-query';
import {
  MyHoldingsSharedService,
  Wealthlane_AwardService_Dtos_MyHoldings_CustomerHoldingsDto,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_MyHoldings_HoldingsDto,
} from '../../services/wealthlane-award-services';

const useGetHoldingForCustomer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardId: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_MyHoldings_CustomerHoldingsDto[] | undefined,
  unknown
> => {
  const holdingList = useQuery(['getHoldingList'], async () => {
    return await handleRequest(
      MyHoldingsSharedService.getApiAwardApiAppMyHoldingsHoldingsForCustomer(awardId)
    );
  });
  return holdingList;
};

export default useGetHoldingForCustomer;
